import { Video, VideoProps } from '@/libraries/design/components/video/src/video';

export type UniformVideoProps = VideoProps;

const UniformVideo = (props: UniformVideoProps) => {
	return <Video {...props} />;
};

export default UniformVideo;
